import React from 'react';
import { getSessionStorage, setSessionStorage } from '@/utils/session';
import { client } from '../api/environment';

const url = 'mobile/';

const getSubscriptions = function (btl?: boolean): Promise<any> {
  return client(`${url}products${btl ? '?c=42' : ''}`, 'GET');
};

// Getting subscriptions with no RETURNED session //
const getSubscriptionsWithoutSession = function (data: any, btl?: boolean): Promise<any> {
  return client(`${url}products${btl ? '?c=42' : ''}`, 'POST', data);
};

const addSubcriptions = function (data: any): Promise<any> {
  return client(`${url}add-subscriptions`, 'POST', data);
};

const validateCprNumber = function (data: any): Promise<any> {
  return client(`${url}validatecprnumber`, 'POST', data);
};

const validatenemidlogin = function (data: any): Promise<any> {
  return client(`${url}validatenemidlogin`, 'POST', data);
};
const getLoginInformation = function (): Promise<any> {
  return client(`login-info`, 'GET');
};

const initNemID = function (data: any): Promise<any> {
  return client(`${url}initiatenemid`, 'POST', data);
};

const checkForNemIdAvailability = function (data: any): Promise<any> {
  return client(`${url}initiatenemid?checkForAvailabilityOnly=true`, 'POST', data);
};

const addPortNumber = function (data: any): Promise<any> {
  return client(`${url}port-mobile-number-from-other-provider`, 'POST', data);
};

const addNewNumber = function (data: any): Promise<any> {
  return client(`${url}choose-mobile-number`, 'POST', data);
};

const addVisibility = function (data: any): Promise<any> {
  return client(`${url}set-visibility-in-directories`, 'POST', data);
};

const addSaldoMax = function (data: any): Promise<any> {
  return client(`${url}set-saldomax`, 'POST', data);
};

const removeSaldoMax = function (data: any): Promise<any> {
  return client(`${url}remove-saldomax`, 'POST', data);
};

const getBasket = function (data: any): Promise<any> {
  return client(`${url}basket`, 'POST', data);
};

const removeSubscription = function (data: any): Promise<any> {
  return client(`${url}remove-subscription`, 'POST', data);
};

const getAvailableNumbers = function (data: any, limit: number, pattern?: string): Promise<any> {
  const numberUrl = pattern
    ? `${url}available-mobile-numbers?limit=${limit ? limit : 12}&pattern=${pattern}`
    : `${url}available-mobile-numbers?limit=${limit ? limit : 12}`;
  return client(numberUrl, 'POST', data, true);
};

const setActivationDate = function (data: any): Promise<any> {
  const useV2 = true;
  return client(`${url}set-delivery-date`, 'POST', data, useV2);
};

const addContactInfo = function (data: any): Promise<any> {
  return client(`${url}set-contact-info`, 'POST', data);
};

const getDibsForm = function (data: any): Promise<any> {
  return client('checkout/dibs-form-fields', 'POST', data);
};

const getEasyUrl = function (data: any): Promise<any> {
  return client('checkout/payment-service-redirect-url', 'POST', data, false, 100000);
};

const getOrderStatus = function (data: any): Promise<any> {
  return client('checkout/order-status', 'POST', data);
};
const getCreditEvaluationStatus = function (data: any): Promise<any> {
  return client(`${url}get-credit-evaluation-status`, 'POST', data);
};

type nominalProductsState = React.Dispatch<React.SetStateAction<any>>;

const fetchProductsFromApi = function (callBackFunction: nominalProductsState) {
  fetch('https://oneshop-salesflow-api-staging.public-internal.lqd.yousee.dk/v1/mobile/products', {
    credentials: 'include'
  }).then(function (response) {
    response.json().then(function (apiData) {
      callBackFunction(apiData.userInfo);
      sessionStorage.setItem('userInfo', JSON.stringify(apiData.userInfo));
      const session = getSessionStorage('_session');
      if (!session) {
        setSessionStorage('_session', apiData._session);
      }
    });
  });
};

export {
  getSubscriptions,
  addSubcriptions,
  removeSubscription,
  fetchProductsFromApi,
  getBasket,
  getSubscriptionsWithoutSession,
  validateCprNumber,
  validatenemidlogin,
  initNemID,
  checkForNemIdAvailability,
  addPortNumber,
  addNewNumber,
  addVisibility,
  addSaldoMax,
  removeSaldoMax,
  getAvailableNumbers,
  setActivationDate,
  addContactInfo,
  getDibsForm,
  getEasyUrl,
  getOrderStatus,
  getCreditEvaluationStatus,
  getLoginInformation
};
